require('./aggregatorCardMovementsView.scss');

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const { withRouter } = require('react-router-dom');
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { AggregatorProductsGenericView } from '../aggregatorProductsGenericView/aggregatorProductsGenericView';

import { LastMovementsTable } from 'commonsComponents/lastMovementsTable';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { OKTableCell } from 'commonsComponents/OKTableCell';
import OKTooltip from 'components/commons/OKTooltip/OKTooltip';
import { OKBoxTitle } from 'commonsComponents/OKBoxTitle';
import { EmptyState } from 'commonsComponents/emptyState';
import { OKButton } from 'commonsComponents/OKButton';
import { LoadingSection } from 'commonsComponents/loadingSection';

import {
  getProductDetails,
  getTransactionsTink,
  requestNextPage,
} from 'actions/aggregator/aggregatorData';

import { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } from 'constants/commonsComponents';
import { NOT_ALLOWED_TINK_AGGREGATOR } from 'constants/flagBasedFeatures';
import { AggregatorCardMovementsTableRow } from 'components/aggregator/aggregatorMovementsTableRow/aggregatorCardMovementsTableRow';
import { AggregatorMovementsFilter } from 'components/aggregator/aggregatorMovementsFilter/aggregatorMovementsFilter';
import { AggregatorMovementsFilterTags } from 'components/aggregator/aggregatorMovementsFilter/aggregatorMovementsFilterTags';

import { OKHeaderSubPageDetails } from 'components/commons/OKHeaderSubPageDetails/OKHeaderSubPageDetails';
import { OKHeaderSubPageValue } from 'components/commons/OKHeaderSubPageValue/OKHeaderSubPageValue';

const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

const language = getLanguage();

class AggregatorCardMovementsViewClass extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { getProductDetails, getTransactionsTink, history, isTinkAggregator, product } = this.props;

    const bankId = product.get('bank');
    const productType = product.get('product');
    const productId = product.get('id');

    if (!product || !bankId || !productId) {
      history.push('/myprofile/global/entities/cards');
    } else {
      !isTinkAggregator
        ? getProductDetails(bankId, productType, productId)
        : getTransactionsTink(productType, productId);
    }
  }

  handleOnClickNext = () => {
    const { product, url, requestNextPage, getTransactionsTink, hasMore, isTinkAggregator } =
      this.props;

    const noProductId = !product.get('id');
    const productType = product.get('product');
    const productId = product.get('id');

    !isTinkAggregator
      ? requestNextPage(noProductId, url)
      : getTransactionsTink(productType, productId, null, null, {}, url, hasMore);
  };

  handleOnClick = () => {
    const { getProductDetails, getTransactionsTink, product, url, isTinkAggregator } = this.props;

    const bankId = product.get('bank');
    const productType = product.get('product');
    const productId = product.get('id');

    !isTinkAggregator
      ? getProductDetails(bankId, productType, productId, url)
      : getTransactionsTink(productType, productId, null, null, {}, url);
  };

  getBreadcrumb = () => {
    return [
      {
        text: formatText('breadcrumb-global'),
        url: '/myprofile/global',
      },
      {
        text: formatText('breadcrumb-otherBanks'),
        url: '/myprofile/global/entities/cards',
      },
      {
        text: formatText('breadcrumb-cards'),
      },
    ];
  };

  renderError = () => {
    const primaryText = formatText('aggregatorMovements-error');
    const button = (
      <OKButton modifier="secondary" onClick={this.handleOnClick}>
        {formatText('aggregatorResume-retry')}
      </OKButton>
    );

    return (
      <div className="aggregator-movements-view__content__error">
        <EmptyState primaryText={primaryText} iconType="nointernet-banking" button={button} />
      </div>
    );
  };

  renderEmptyState = () => {
    const primaryText = formatText('aggregatorMovements-noMovements');

    return (
      <div className="aggregator-movements-view__content__noresults">
        <EmptyState primaryText={primaryText} iconType="noresult" />
      </div>
    );
  };

  renderButtons = () => {
    const { hasMore } = this.props;

    if (!hasMore) return null;

    return (
      <div className="aggregator-movements-view__buttons">
        <OKButton onClick={this.handleOnClickNext}>
          <FormattedText value="aggregatorCard-showMore" />
        </OKButton>
      </div>
    );
  };

  renderTable = () => {
    const { movements, immFlagBasedFeatures, isTinkAggregator } = this.props;

    if (!movements) return;

    const categoryFormattedText = (
      <span>
        <FormattedText value="myMoneyTransactions-category" format="firstUppercase" />
      </span>
    );
    const dateFormattedText = (
      <span>
        <FormattedText
          value="myMoneyTransactions-date"
          className="card-last-movements-table__cell-header-date"
          format="firstUppercase"
        />
      </span>
    );
    const categoryTooltip = (
      <OKTooltip
        content="myMoneyTransactions-categoryTooltip"
        offset={[0, -10]}
        target={categoryFormattedText}
        type="descriptive"
      />
    );

    const movementsById = movements.reduce((lv, cv, i) => lv.merge({ [i]: cv }), Map());
    const movementsByOrder = movements.map((v, i) => i.toString());

    return (
      <LastMovementsTable
        // immFilter={immFilter}
        groupByDate={true}
        rowComponent={AggregatorCardMovementsTableRow}
        immTransactionsByOrder={movementsByOrder}
        immTransactionsById={movementsById}
        immFlagBasedFeatures={immFlagBasedFeatures}
        columnsCount={4}
        groupHeaderClassName={'aggregator-movements-view__table__group-header'}
        isExpandable={false}
        id={'aggregator-card-last-movements'}
        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
        language={language}
        isTinkAggregator={isTinkAggregator}
      >
        <thead>
          <OKTableRow asHeader={true}>
            <OKTableCell asHeader={true}>
              <OKTooltip
                content="cards-dateTooltip"
                offset={[0, -10]}
                target={dateFormattedText}
                type="descriptive"
              />
            </OKTableCell>
            <OKTableCell asHeader={true} className="text-center">
              {categoryTooltip}
            </OKTableCell>
            <OKTableCell asHeader={true}>
              <FormattedText value="myMoneyTransactions-description" format="firstUppercase" />
            </OKTableCell>
            <OKTableCell
              asHeader={true}
              className="aggregator-movements-view__table__cell-header-import"
            >
              <FormattedText value="myMoneyTransactions-amount" format="firstUppercase" />
            </OKTableCell>
          </OKTableRow>
        </thead>
      </LastMovementsTable>
    );
  };

  renderContentHeader = () => {
    const { product, isTinkAggregator } = this.props;

    const productType = product.get('product');
    const productId = product.get('id');
    const bankId = product.get('bank');

    let headerTitle = <div>{formatText('cardMovements-movementsTitle')}</div>;

    return (
      <header className="aggregator-movements-view__header">
        <div className="row">
          <div className="aggregator-movements-view__header__title col-xs-6">
            <OKBoxTitle value={headerTitle} />
          </div>
          <div className="aggregator-movements-view__header__filters col-xs-6">
            <AggregatorMovementsFilter
              productType={productType}
              productId={productId}
              bankId={bankId}
              isTinkAggregator={isTinkAggregator}
            />
          </div>
        </div>
        <div>
          <AggregatorMovementsFilterTags
            productType={productType}
            productId={productId}
            bankId={bankId}
            isTinkAggregator={isTinkAggregator}
          />
        </div>
      </header>
    );
  };

  renderContent = () => {
    const { movements, loading, error } = this.props;

    if (error) return this.renderError();

    if (!loading && !movements) return this.renderEmptyState();

    return (
      <Fragment>
        {this.renderContentHeader()}
        {this.renderTable()}
        {loading && <LoadingSection />}
        {this.renderButtons()}
      </Fragment>
    );
  };

  renderHeader = extra => {
    const { product, isTinkAggregator } = this.props;

    const value = !isTinkAggregator ? product.get('disposed') : product.disposed;

    return (
      <OKHeaderSubPageDetails isSubPageOneLine={false}>
        <OKHeaderSubPageValue
          textKey="aggregator-cardViewItem"
          value={product && value}
          isAmountType={true}
        />
        {extra}
      </OKHeaderSubPageDetails>
    );
  };

  render() {
    const { product } = this.props;

    const title = product.get('alias');
    const subtitle = product.get('number');

    return (
      <AggregatorProductsGenericView
        renderHeaderDetails={product && this.renderHeader}
        breadcrumb={this.getBreadcrumb()}
        title={title}
        subtitle={subtitle}
      >
        <div className="aggregator-movements-view__content">{this.renderContent()}</div>
      </AggregatorProductsGenericView>
    );
  }
}

AggregatorCardMovementsViewClass.propTypes = {
  history: PropTypes.object.isRequired,
  movements: PropTypes.object,
  product: PropTypes.object,
  getProductDetails: PropTypes.func,
  url: PropTypes.number,
  hasMore: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.object,
  requestNextPage: PropTypes.func,
  immFlagBasedFeatures: PropTypes.object,
  getTransactionsTink: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorCardMovementsView = withRouter(connect(
  (state, ownProps) => {
    const isTinkAggregator = state.flagBasedFeatures.get(NOT_ALLOWED_TINK_AGGREGATOR);

    return {
      product: state.aggregatorData.getIn(['data', 'products', ownProps.match.params.id]),
      movements: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'movements'], null),
      url: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'url'], null),
      hasMore: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'hasMore'], false),
      loading: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'loading'], false),
      error: state.aggregatorData.getIn(['details', ownProps.match.params.id, 'error'], null),
      immFlagBasedFeatures: state.flagBasedFeatures,
      isTinkAggregator,
    };
  },
  {
    getProductDetails,
    getTransactionsTink,
    requestNextPage,
  }
)(AggregatorCardMovementsViewClass));

export { AggregatorCardMovementsView };
